import { ScrollArea, Stack, Title } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form';

import { TSDViewHouseFormValues } from '@e-origin/contracts';

import { EditArray } from '@components';
import { HousePerson } from './HousePerson';

interface HouseStakeholdersProps {
  houseForm: UseFormReturnType<TSDViewHouseFormValues>;
  disabled: boolean;
}

export const HouseStakeholders: React.FC<HouseStakeholdersProps> = ({ houseForm, disabled }) => {
  return (
    <ScrollArea h="50vh" offsetScrollbars="y">
      <Stack mt="md" gap="xl">
        <HousePerson houseForm={houseForm} disabled={disabled} personTitle="Consignor" personFieldBasePath="consignor" />
        <HousePerson houseForm={houseForm} disabled={disabled} personTitle="Consignee" personFieldBasePath="consignee" />
        <HousePerson houseForm={houseForm} disabled={disabled} personTitle="Notify party" personFieldBasePath="notifyParty" />

        <Stack mb="sm">
          <Title order={5} fw={600}>
            Additional supply chain actor
          </Title>

          <EditArray
            addButtonLabel="Add"
            addButtonDataPW="add-additional-supply-chain-actor-btn"
            form={houseForm}
            inputs={[
              {
                type: 'MultiLang',
                label: 'Role',
                name: 'role',
                code: 'CL704',
                width: 40,
              },
              {
                type: 'Input',
                label: 'Identification number',
                name: 'identificationNumber',
                width: 38,
              },
            ]}
            arrayPath="additionalSupplyChainActor"
            disabled={disabled}
            codelistSystemsConfig={{}}
          />
        </Stack>
      </Stack>
    </ScrollArea>
  );
};
